<template>
    <div class="title">
        <div class="title-text" :class="{ 'title-text-center': isCenter }"><span :style="{ color: color }">{{
            props.title.slice(0, 2) }}</span>{{
                    props.title.slice(2) }}</div>
        <div class="title-more" :class="{ 'title-more-center': isCenter }">{{ props.titleMore }}</div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue'
const props = defineProps({
    title: {
        type: String,
        default: "资讯动态"
    },
    titleMore: {
        type: String,
        default: "NWES"
    },
    isCenter: {
        type: Boolean,
        default: false
    },
    color: {
        type: String,
        default: "@xtxColor"
    }
})
</script>

<style lang="less" scoped>
.title {
    font-size: 3.125rem;
    font-weight: bold;
    position: relative;
    height: 8.75rem;
    width: 100%;
    white-space: nowrap;

    .title-text {
        position: absolute;
        top: .375rem;
        left: 0;

        span {
            &:nth-child(1) {
                color: @xtxColor;
            }
        }
    }

    .title-more {
        font-size: 6.25rem;
        -webkit-text-stroke: 2px #3E3A39;
        opacity: 0.1;
        color: transparent; //字体颜色设置为透明
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
    }

    .line {
        width: 100%;
        height: .125rem;
        background: #fff;
        position: absolute;
        bottom: 0;
        opacity: 0.2;
    }
}

.title-text-center {
    position: absolute;
    top: .375rem;
    left: 50% !important;
    transform: translateX(-50%) !important;
}

.title-more-center {
    position: absolute;
    top: 0;
    left: 50% !important;
    transform: translateX(-50%) !important;
}
</style>